import React, { useEffect, useRef } from 'react';

import { QuickFindStoreContainer, useQuickFindActions } from '../index';

const RovoJourneyIdUrlSync = ({
	incomingRovoJourneyId,
}: {
	incomingRovoJourneyId?: string;
}): null => {
	const { setRovoJourneyId } = useQuickFindActions();
	const previousIncomingRovoJourneyId = useRef(incomingRovoJourneyId);

	useEffect(() => {
		if (incomingRovoJourneyId && incomingRovoJourneyId !== previousIncomingRovoJourneyId.current) {
			setRovoJourneyId(incomingRovoJourneyId);
		}
		previousIncomingRovoJourneyId.current = incomingRovoJourneyId;
	}, [incomingRovoJourneyId, setRovoJourneyId]);

	return null;
};

export const QuickFindStoreProvider = ({
	children,
	initialRovoJourneyId,
	shouldInitializeRovoJourneyId = false,
}: {
	children: React.ReactNode;
	initialRovoJourneyId?: string;
	shouldInitializeRovoJourneyId?: boolean;
}): React.JSX.Element => {
	const scopedInitialRovoJourneyId = shouldInitializeRovoJourneyId
		? initialRovoJourneyId
		: undefined;

	return (
		<QuickFindStoreContainer
			initialRovoJourneyId={scopedInitialRovoJourneyId}
			shouldInitializeRovoJourneyId={shouldInitializeRovoJourneyId}
		>
			<RovoJourneyIdUrlSync incomingRovoJourneyId={scopedInitialRovoJourneyId} />
			{children}
		</QuickFindStoreContainer>
	);
};
